import createLucideIcon from '../createLucideIcon';

const Minus = createLucideIcon('MinusIcon', [
  ['line', { x1: '5', y1: '12', x2: '19', y2: '12', key: '1smlys' }],
]);

export default Minus;
